import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgCo = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#FFE800",
      d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#00148E",
      d: "M24 12c0 6.627-5.373 12-12 12C5.476 24 .168 18.794.004 12.31L0 12z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#DA0010",
      d: "M22.39 18c-2.075 3.586-5.949 6-10.39 6a11.99 11.99 0 0 1-10.39-6z"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgCo;